export default (
  state = {
    list: [],
    selectedLpMetrics: {},
    isFetchingSelectedLpMetrics: true,
  },
  action
) => {
  switch (action.type) {
    case "GET_LPS_LIST_START":
      return { ...state, isFetchingLpsList: true };

    case "GET_LPS_LIST_SUCCESS":
      return {
        ...state,
        isFetchingLpsList: false,
        list: action.data,
      };

    case "GET_LPS_LIST_FAIL":
      return { ...state, isFetchingLpsList: false, list: [] };

    case "GET_LP_METRICS_START":
      return {
        ...state,
        isFetchingSelectedLpMetrics: true,
        selectedLpMetrics: {},
      };

    case "GET_LP_METRICS_FAIL":
      return {
        ...state,
        isFetchingSelectedLpMetrics: false,
        selectedLpMetrics: {},
      };

    case "GET_LP_METRICS_SUCCESS":
      return {
        ...state,
        isFetchingSelectedLpMetrics: false,
        selectedLpMetrics: action.data,
      };

    case "SEND_REMINDER_LOADING":
      return {
        ...state,
        isSendingReminder: true,
        isSendingReminderSuccess: false,
        isSendingReminderFail: false,
      };

    case "SEND_REMINDER":
      return {
        ...state,
        isSendingReminder: false,
        isSendingReminderSuccess: !action.error ? true : false,
        isSendingReminderFail: action.error ? true : false,
      };

    case "RESET_REMINDER_STATUS":
      return {
        ...state,
        isSendingReminder: false,
        isSendingReminderSuccess: false,
        isSendingReminderFail: false,
      };
    default:
      return state;
  }
};
